import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageLayout } from "@/components/Layout/PageLayout";
import { useLanguage } from "@/contexts/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <PageLayout showDrawerTrigger>
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="space-y-6"
        >
          {/* Friendly icon */}
          <motion.div
            initial={{ rotate: -10 }}
            animate={{ rotate: 10 }}
            transition={{ 
              duration: 2, 
              repeat: Infinity, 
              repeatType: "reverse",
              ease: "easeInOut"
            }}
            className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-muted"
          >
            <Compass className="w-10 h-10 text-muted-foreground" />
          </motion.div>

          {/* Heading */}
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-foreground">
              {t('notFound.heading')}
            </h1>
            <p className="text-muted-foreground max-w-xs mx-auto">
              {t('notFound.description')}
            </p>
          </div>

          {/* Action */}
          <Button 
            onClick={() => navigate("/")}
            size="lg"
            className="min-w-[200px]"
          >
            {t('notFound.goHome')}
          </Button>
        </motion.div>
      </div>
    </PageLayout>
  );
};

export default NotFound;
